import { post } from '~/plugins/nikan-api'
import _ from 'lodash'
import Endpoints from '@nikan/endpoints'
import { commit } from 'lodash/seq'
import { NotifyCenterUpdateStatus } from '@/enums/system'

const KEYS = {
  Prepare: 'PREPARE',
  Clear: 'CLEAR',
  Update: 'UPDATE',
  ModifyBalances: 'ModifyBalances',
  SetStatus: 'SETSTATUS',
  AddOrModified: NotifyCenterUpdateStatus.AddOrModified,
  Added: NotifyCenterUpdateStatus.Added,
  Deleted: NotifyCenterUpdateStatus.Deleted,
}

export default {
  namespaced: true,
  state: {
    count: 0,
    serverSide: false,
    centers: [],
  },
  mutations: {
    [KEYS.Prepare](state, list) {
      if (list && Array.isArray(list)) {
        state.centers = list
      } else {
        state.centers = []
      }
    },

    [KEYS.Clear](state) {
      state.centers = []
    },
    [KEYS.Update](state, list) {
      for (let center of list) {
        let index = state.centers.findIndex(c => c.id === center.id)

        if (index > -1)
          state.centers.splice(index, 1, center)
      }
    },
    [KEYS.SetStatus](state, count) {
      state.count = count
      state.serverSide = count > 1000
    },
    [KEYS.ModifyBalances](state, list) {
      for (let newCenter of list) {
        let index = state.centers.findIndex(c => c.id === newCenter.floatingCenterId)
        if (index > -1) {
          const floatingCenter = { ...state.centers[index], ...newCenter }
          state.centers.splice(index, 1, floatingCenter)
        }
      }
    },
    [KEYS.AddOrModified](state, floatingCenter) {
      if (!floatingCenter)
        return
      let index = state.centers.findIndex(c => c.id === floatingCenter.id)
      if (index > -1) {
        state.centers.splice(index, 1, floatingCenter)
      } else {
        state.centers.push(floatingCenter)
        const center = state.centers.find(x => x.id === floatingCenter.id)
        const foundParent = state.centers.find(x => x.id === center?.parent?.id)
        if (foundParent)
          foundParent.hasChild = true
      }
    },
    [KEYS.Deleted](state, floatingCenterId) {
      let index = state.centers.findIndex(c => c.id === floatingCenterId)
      if (index > -1) {
        const center = state.centers.find(x => x.id === floatingCenterId)
        state.centers.splice(index, 1)
        if (center.parent) {
          const parentsChild = state.centers.filter(x => x.parent && x.parent.id === center.parent.id)
          if (!parentsChild.length) {
            const parent = state.centers.find(x => x.id === center.parent.id)
            parent.hasChild = false
          }
        }
      }
    },
  },
  actions: {
    async setStatus({ dispatch, commit, state }, count) {
      commit(KEYS.SetStatus, count)
    },
    async refresh({ dispatch, commit, state }, options) {
      if (state.serverSide && !options.ignoreServerSide)
        return

      options = _.extend({ force: false }, options)

      var key = 'floating-centers'

      // if (options.force !== true) {
      //   var cached = await dispatch('cache/get', key, { root: true })

      //   if (cached != null) {
      //     commit(KEYS.Prepare, cached)
      //     return
      //   }
      // }

      const api = () => post(Endpoints.getUrl('floatingCenters.list'), { includeAccounts: true, }, null, { preventConcurrent: false })
        .then(result => {
          if (result.success) {
            if (!state.serverSide)
              commit(KEYS.Prepare, result.data.items)
            return result.data.items
          }
        })
      if (options.force) {
        return await api()
      } else {
        return state.centers
      }
    },
    getCentersByAccountIdAndItsParents({ state, getters, rootGetters }, obj) {
      let parents = rootGetters['accounts/parents'](obj.accountId)
      if (parents == null) {
        return
      }

      parents.splice(0, 0, obj.accountId)
      let centers = []
      for (let p of parents) {
        centers.push(...getters['getCentersByAccountId'](p, obj.centerLevel))
      }
      return centers
    },
    getCentersByCenterLevel({ state, getters, rootGetters }, level) {
      if (level === 0) return state.centers
      return state.centers.filter(x => x.relatedAccountsByLevel.some(y => y.centerLevel === level))

    },
    async getMaxCentersLevelByAccountId({ state, getters, rootGetters }, accountId) {
      let parents = rootGetters['accounts/parents'](accountId)
      if (parents == null) {
        return
      }

      parents.splice(0, 0, accountId)
      let centers = []
      for (let p of parents) {
        centers.push(...getters['getCentersByAccountId'](p))
      }
      centers = centers.filter(x => !x.hasChild)
      let max = 1
      for (var i = 0; i < centers.length; i++) {
        for (var j = 0; j < centers[i].relatedAccountsByLevel.length; j++) {
          if (centers[i].relatedAccountsByLevel[j].accountId === accountId) {
            max = Math.max(centers[i].relatedAccountsByLevel[j].centerLevel || 1, max)
          }
        }
      }
      return max
    },
    async getMaxCentersLevel({ state, getters, rootGetters }) {
      let max = rootGetters['accounts/getMaxCentersLevel']
      return max
      // let centers = getters['all']
      // centers = centers.filter(x => !x.hasChild)
      // let max = 1
      // for (var i = 0; i < centers.length; i++) {
      //   for (var j = 0; j < centers[i].relatedAccountsByLevel.length; j++) {
      //     max = Math.max(centers[i].relatedAccountsByLevel[j].centerLevel, max)
      //   }
      // }
      // return max
    },
    clear({ commit }) {
      commit(KEYS.Clear)
    },
    modifyCenters({ state, getters, rootGetters, commit }, centers) {
      commit(KEYS.ModifyBalances, centers)
    },
    updateCenters({ state, getters, rootGetters, commit }, data) {
      if (state.serverSide)
        return
      if (data.status === KEYS.Deleted) {
        commit(KEYS.Deleted, data.floatingCenterId)
      }
      else {
        return post(Endpoints.getUrl('floatingCenters.get'), { id: data.floatingCenterId, includeRelatedAccounts: true }, null, { preventConcurrent: false })
          .then(result => {
            if (result.success) {
              commit(KEYS.AddOrModified, result.data)
            }
          })
      }
    }
  },
  getters: {
    all: state => {
      return state.centers
    },
    leaves: state => {
      return state.centers.filter(item => item.hasChild === false)
    },
    getById: (state, getters, rootState, rootGetters) => async (centerId, preventConcurrent = true) => {
      if (getters.isServerSide)
        return (await post(Endpoints.getUrl('floatingCenters.get'), { id: centerId }, null, { preventConcurrent: preventConcurrent })).data
      else
        return _.head(state.centers.filter(x => x.id === centerId))
    },
    getCentersByAccountId: state => (accountId, centerLevel) => {
      return state.centers.filter(x => x.relatedAccountIds.some(y => y === accountId) && (!centerLevel || (x.relatedAccountsByLevel.some(y => y.accountId === accountId && y.centerLevel === centerLevel))))
    },
    getCenterLevelOfAccount: state => (centerId, accountId) => {
      return _.head(state.centers.filter(x => x.id === centerId))?.relatedAccountsByLevel?.find(x => x.accountId === accountId)?.centerLevel || 0
    },
    leavesByGroup: (state, getters) => groupKey => {
      return getters['leaves'].filter(x => x.group === groupKey)
    },
    allFilteredByGroup: (state, getters) => groupKey => {
      return state.centers.filter(x => x.group === groupKey)
    },
    getCenterProfile: (state, getters) => center => {
      if (center?.imageUrl)
        return center.imageUrl
      else if (center && center.group && center.group != 0)
        return new URL(`/src/assets/Avatars/${center.group}.svg`, import.meta.url).href
      else
        return null
    },
    getMaxCentersLevelByAccountId: (state, getters, rootState, rootGetters) => accountId => {
      return rootGetters['accounts/getById'](accountId)?.maxCenterLevel || 1
    },
    getMaxCenterTreeLevel: state => {
      return _.maxBy(state.centers, 'level')?.level || 2
    },
    getMetaDatasByCenterId: (state, getters, rootState, rootGetters) => async (centerId, preventConcurrent = true) => {
      let center
      if (getters.isServerSide)
        center = await getters.getById(centerId, preventConcurrent)
      else
        center = state.centers.find(x => x.id === centerId)

      if (!center)
        throw Error(`Center not found`)

      const schemas = rootGetters['metadata/schemas']
      var metaDatas = {}

      for (let schema of schemas) {
        if (schema.subject.split('_')[1] === center.group)
          metaDatas[schema.name] = center.metaDatas.find(x => x.metaDataSchema.id === schema.id)?.value
      }

      return metaDatas
    },
    isServerSide: (state) => {
      return state.serverSide
    },
  }
}
